<div id="app-component-view" style="width: 100%; height: 100%; display: none">
  @if (enableComponents) {
    <router-outlet></router-outlet>
  }
</div>
<router-outlet name="printing"></router-outlet>

<ng-template #companyLogoTemplate>
  <div>
    <div style="display: flex; flex-direction: column; align-items: center">
      <div class="st_loading__img"
      [style.background-image]="'url(' + (companyLogo ?? 'var(--loading-image-default)') + ')'"></div>

      <div class="c-loader"></div>
    </div>
  </div>
</ng-template>
<app-toast></app-toast>

